export default __webpack_public_path__ + "static/media/sony_logo_white_RGB.d974b6a8.png";